module.exports = __webpack_public_path__ + "static/img/hero_600.13cbabe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/hero_600.png
// module id = 2llD
// module chunks = 0